import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { NgxLoadingModule } from "ngx-loading";
import { Oauth2ButtonComponent } from "./oauth2-button/oauth2-button.component";
import { CallbackComponent } from "./xero/callback/callback.component";
import { AuthGuard } from "./xero/guards/auth.guard";
import { CallbackGuard } from "./xero/guards/callback.guard";

@NgModule({
  imports: [
    CommonModule,
    NgxLoadingModule
  ],
  declarations: [
    Oauth2ButtonComponent,
    CallbackComponent
  ],
  exports: [
    Oauth2ButtonComponent,
    CallbackComponent
  ]
})
export class IntegrationsSharedModule {
  public static forRoot(): ModuleWithProviders<IntegrationsSharedModule> {
    return {
      ngModule: IntegrationsSharedModule,
      providers: [
        CallbackGuard,
        AuthGuard
      ]
    };
  }
}
